import useGlobalContext from '$hooks/use-global-context';
import { useTranslationClient } from '@brahma/hooks';
import type { UseTranslationOptions } from 'react-i18next';

const useLocale = (
  namespace: string | string[],
  options?: UseTranslationOptions<string> | undefined,
  cookieName?: string | undefined
) => {
  const { state } = useGlobalContext();
  const { t } = useTranslationClient(
    state.locale.lang,
    namespace,
    options,
    cookieName
  );

  return { t };
};

export default useLocale;
